import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import getSymbolFromCurrency from 'currency-symbol-map';

import ButtonComponent from 'components/button/ButtonComponent';

class TestPaymentPageComponent extends Component {
  componentDidMount() {
    const { store } = this.props;
    store.setPageLoading(false);
  }

  authorizeAction = () => {
    const { store } = this.props;

    store.charge();
  };

  redirectToFailedAction = () => {
    const { store } = this.props;

    store.redirectToFailed();
  };

  expireAction = () => {
    const { store } = this.props;

    store.expire();
  };

  failedAction = () => {
    const { store } = this.props;

    store.fail();
  };

  cancelAction = () => {
    const { store } = this.props;

    if (store.source.type === 'three_d_secure') {
      store.fail({
        error_code: 'DECLINED',
        error_description: 'Customer cancelled test payment.'
      });
    } else {
      store.cancel();
    }
  };

  grabPayAuthorizeAction = () => {
    const { store } = this.props;

    window.location.href = `${process.env.REACT_APP_CORE_API_URL}/v1/grab_pay/webhook?state=test_state_${store.source.id}`;
  };

  render() {
    const { store } = this.props;

    const currencySymbol = getSymbolFromCurrency(store.source.currency);

    let actionFail = this.redirectToFailedAction;
    let actionAuthorize = this.authorizeAction;
    let paymentMethod = '';

    if (store.source.type === 'atome') {
      paymentMethod = 'Atome';
    } else if (store.source.type === 'billease') {
      paymentMethod = 'Billease';
    } else if (store.source.type === 'gcash') {
      paymentMethod = 'GCash';
    } else if (store.source.type === 'paymaya') {
      paymentMethod = 'Maya';
    } else if (store.source.type === 'grab_pay') {
      paymentMethod = 'GrabPay';
      actionAuthorize = this.grabPayAuthorizeAction;
    } else if (store.source.type === 'shopee_pay') {
      paymentMethod = 'ShopeePay';
    } else if (store.source.type === 'qrph') {
      paymentMethod = 'QRPH';
      actionFail = this.failedAction;
    } else if (store.source.type === 'three_d_secure') {
      paymentMethod = '3DS';
      actionFail = this.failedAction;
    }

    const showQRPH = store.source.status === 'chargeable' && store.source.type === 'qrph';

    return (
      <div className="test-payment-page">
        <h1 className="Head">{`${paymentMethod} Test Payment Page`}</h1>
        <p className="SubHead">
          This is a&nbsp;
          <span>test payment</span>
          {` of ${currencySymbol} ${store.formattedAmount}.`}
        </p>
        {store.source.id !== undefined &&
          store.source.id !== '' &&
          (store.source.status === 'pending' || showQRPH) && (
            <div className="ActionButtons">
              <ButtonComponent
                type="primary"
                onClick={actionAuthorize}
                disabled={store.authorizeLoading || store.processing}
                loading={store.authorizeLoading}
              >
                Authorize Test Payment
              </ButtonComponent>
              {!['atome', 'billease', 'gcash'].includes(store.source.type) && (
                <ButtonComponent
                  disabled={store.failLoading || store.processing}
                  loading={store.failLoading}
                  onClick={actionFail}
                >
                  Fail Test Payment
                </ButtonComponent>
              )}
              {(store.source.type === 'gcash' || store.source.type === 'qrph') && (
                <ButtonComponent
                  disabled={store.failLoading || store.processing}
                  loading={store.failLoading}
                  onClick={this.expireAction}
                >
                  {store.source.type === 'gcash'
                    ? 'Expire/Fail Test Payment'
                    : 'Expire Test Payment'}
                </ButtonComponent>
              )}
              {['grab_pay', 'three_d_secure', 'billease', 'atome', 'shopee_pay'].includes(
                store.source.type
              ) && (
                <ButtonComponent
                  disabled={store.failLoading || store.processing}
                  loading={store.failLoading}
                  onClick={this.cancelAction}
                >
                  Cancel Test Payment
                </ButtonComponent>
              )}
            </div>
          )}
      </div>
    );
  }
}

TestPaymentPageComponent.propTypes = {
  store: PropTypes.shape({
    authorizeLoading: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    charge: PropTypes.func.isRequired,
    expire: PropTypes.func.isRequired,
    fail: PropTypes.func.isRequired,
    failLoading: PropTypes.bool.isRequired,
    formattedAmount: PropTypes.string.isRequired,
    processing: PropTypes.bool.isRequired,
    redirectToFailed: PropTypes.func.isRequired,
    source: PropTypes.shape({
      id: PropTypes.string,
      currency: PropTypes.string,
      redirect: PropTypes.shape({
        return_url: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string
    }),
    setPageLoading: PropTypes.func.isRequired
  }).isRequired
};

export default inject(stores => {
  return {
    store: stores.store.source
  };
})(observer(TestPaymentPageComponent));
